export default function Logo({ size = 40, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} data-testid="brand-logo" aria-label="Logo Prestige Drive">
      <defs>
        <linearGradient id="pdGoldLogo" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#e3c07a" />
          <stop offset="0.5" stopColor="#c9a24d" />
          <stop offset="1" stopColor="#a17c2e" />
        </linearGradient>
      </defs>
      <rect x="3" y="3" width="58" height="58" rx="16" fill="#0d1017" stroke="url(#pdGoldLogo)" strokeWidth="2.5" />
      <rect x="8.5" y="8.5" width="47" height="47" rx="12" fill="none" stroke="url(#pdGoldLogo)" strokeWidth="0.8" opacity="0.45" />
      <path d="M20 46 V18 h9 a7.5 7.5 0 0 1 0 15 h-9" fill="none" stroke="url(#pdGoldLogo)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M37 46 V18 h6.5 a10.5 14 0 0 1 0 28 H37" fill="none" stroke="url(#pdGoldLogo)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
